import script from "./NoteTable.vue?vue&type=script&setup=true&lang=js"
export * from "./NoteTable.vue?vue&type=script&setup=true&lang=js"

import "./NoteTable.vue?vue&type=style&index=0&id=4f2b21c5&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f2b21c5"]])

export default __exports__